import {
	IonButton,
	IonCol,
	IonIcon,
	IonImg,
	IonInput,
	IonItem,
	IonItemDivider,
	IonLabel,
	IonList,
	IonListHeader,
	IonRadio,
	IonRadioGroup,
	IonSelect,
	IonSelectOption,
	IonToast,
	isPlatform,
} from "@ionic/react";
import Geocode from "react-geocode";
import React, { useEffect, useState } from "react";
import {
	CHANGE,
	CURRENT_LOCATION,
	SAVE,
	ADDRESS_SAVED_SUCCESSFULLY,
	PLEASE_ENTER_HOUSE_FLAT_NO,
	PLEASE_ENTER_LANDMARK,
	PLEASE_SELECT_CITY,
	PLEASE_SELECT_STATE,
	PLEASE_ENTER_PINCODE,
	PLEASE_SELECT_ADDRESS_TYPE,
	SAVED_ADDRESS,
	NO_SAVED_ADDRESS,
	DENIED,
	UNIQUE_ADDRESS_TYPE,
} from "../../constants";
import "../../global.scss";
import { AddressTextField } from "../CustomComponents/AddressTextField";
import PageHeading from "../CustomComponents/PageHeading";
import ConfirmPageHeading from "../CustomComponents/confirmHeader";
import Maps, { GoogleApiKey } from "../../utils/maps";
import {
	storeCityAndState,
	storeCurrentLatLong,
	storeUserEditAddressId,
	storeUserMapAddress,
	updateEditedUserDetails,
	userAddress,
	setDefAddress,
	editParticularAddress,
	saveLocationPermissionStatus,
	saveAddressRef,
} from "../../Store/Actions";
import { connect } from "react-redux";
import {
	COLLECTIONS,
	saveDocumentData,
	saveSubCollectionData,
	setDefaultAddress,
} from "../../firebase";
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import { knowLocationPermission } from "./myAddresses";
import ReactTooltip from "react-tooltip";
import {
	alphabitsLetters,
	checkForOnlyNumber,
	checkMediaQuery,
	isSplChar,
} from "../../utils";
import { ToastMessage } from "../../utils/toastMessage";
import { arrowBackOutline } from "ionicons/icons";

Geocode.setApiKey("AIzaSyAJiQDsW8req1tKBNcjMeB3clQmge3wHCg");

export const convertLatLongIntoAddress = (lat: any, long: any, props: any) => {
	Geocode.fromLatLng(lat, long).then(
		(response: any) => {
			const address = response.results[0].formatted_address;
			props.storeUserMapAddress(address);
			fetchCityAndState(response, props);
		},
		(error: any) => {
			console.error(error, "error");
		}
	);
};

export const convertAddressIntoLatLong = (address: any, props: any) => {
	Geocode.fromAddress(address).then(
		(response: any) => {
			const { lat, lng } = response.results[0].geometry.location;
			props.storeCurrentLatLong(lat, lng);
		},
		(error: any) => {
			console.error(error);
		}
	);
};

export const fetchCityAndState = (response: any, props: any) => {
	let city, state, country, pincode;
	for (let i = 0; i < response.results[0].address_components.length; i++) {
		for (let j = 0; j < response.results[0].address_components[i].types.length; j++) {
			switch (response.results[0].address_components[i].types[j]) {
				case "locality":
					city = response.results[0].address_components[i].long_name;
					break;
				case "administrative_area_level_1":
					state = response.results[0].address_components[i].long_name;
					break;
				case "country":
					country = response.results[0].address_components[i].long_name;
					break;
				case "postal_code":
					pincode = "111111"; //response.results[0].address_components[i].long_name;
			}
		}
	}
	const payload = {
		cityFetched: city,
		stateFetched: state,
		pincode: pincode,
	};
	props.storeCityAndState(payload);
};

const AddNewAddress: React.FC = (props: any) => {
	const [houseNo, setHouseNo] = useState("");
	const [landmark, setLandmark] = useState("");
	const [city, setCity] = useState("");
	const [state, setState] = useState("");
	const [pincode, setPincode] = useState("111111");
	const [latitude, setLatitude] = useState("");
	const [longitude, setLongitude] = useState("");
	const [addType, setAddType] = useState("");
	const [searchUi, setSearchUi] = useState(false);
	const [autocomRef, setAutocomRef] = useState(null);
	const [errorMsg, showErrorMsg] = useState("");
	const [tooltipText, setTooltipText] = useState("");
	const [toast, setToast] = React.useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});
	const [allowedLocPer, setAllowLocPer] = useState("allowed");

	var fooRef = null as any;

	useEffect(() => {
		return function cleanup() {
			props.storeUserEditAddressId("");
		};
	}, []);
	const [isDisabled, setDisabled] = useState(false);

	const onAutoPlaceChanged = (data: any) => {
		const { formatted_address } = data.getPlace();
		convertAddressIntoLatLong(formatted_address, props);
		Geocode.fromAddress(formatted_address).then(
			(response: any) => {
				fetchCityAndState(response, props);
				setSearchUi(false);
				setHouseNo("");
				setLandmark("");
				setAddType("");
			},
			(error: any) => {
				showErrorMsg("No results found");
				// console.error(error);
			}
		);
		props.storeUserMapAddress(formatted_address);
		//  setSearchUi(false);
	};

	const getUserCurrentLocation = () => {
		navigator.geolocation.getCurrentPosition(
			(resp) => {
				setAllowLocPer("allowed");
				const { coords } = resp;
				const { latitude, longitude } = coords;
				setLatitude(`${latitude}`);
				setLongitude(`${longitude}`);
				props.storeCurrentLatLong(latitude, longitude);

				// console.log("186 Lat Lng =====", props);
				Geocode.fromLatLng(latitude, longitude).then(
					(response: any) => {
						const address = response.results[0].formatted_address;
						props.storeUserMapAddress(address);
						fetchCityAndState(response, props);
					},
					(error: any) => {
						console.error(error);
					}
				);
			},
			(e: any) => {
				console.error(e, "e");
				if (e.message === "User denied Geolocation") {
					setAllowLocPer("denied");
					setToast({
						showToast: true,
						toastMessage: "Please provide location permission",
						severity: "warning",
					});
				}
			}
		);
	};

	useEffect(() => {
		if (!!props.userAddressList.length && !!props.match.params.id) {
			const prefillEdit = props.userAddressList.find(
				(val: any) => val.did === props.match.params.id
			);
			const {
				addressType,
				addressline1,
				city,
				landmark,
				postalCode,
				state,
				latitude,
				longitude,
			} = prefillEdit || {};
			props.storeCurrentLatLong(latitude, longitude);
			setLatitude(latitude);
			setLongitude(longitude);
			setHouseNo(addressline1);
			setLandmark(landmark);
			setCity(city);
			setState(state);
			setPincode(postalCode);
			setAddType(addressType);
		}
	}, []);

	useEffect(() => {
		// console.log("props.map_address ===", props);
		if (!props.map_address || !props.curLat || !props.curLong) {
			getUserCurrentLocation();
		}
		if (!!props.storeCity) {
			setCity(props.storeCity);
		} else {
			setCity("");
		}
		if (!!props.storeState) {
			setState(props.storeState);
		} else {
			setState("");
		}
		!!props.storePincode ? setPincode(props.storePincode) : setPincode("111111");
	}, [props.storeCity, props.storeState, props.storePincode]);

	const onSaveAddress = async () => {
		try {
			// console.log("Save Add ......", city);
			if (!houseNo.trim().length) {
				throw PLEASE_ENTER_HOUSE_FLAT_NO;
			}
			if (!landmark.trim().length) {
				throw PLEASE_ENTER_LANDMARK;
			}
			if (!city || !alphabitsLetters(city)) {
				throw PLEASE_SELECT_CITY;
			}
			if (!state || !alphabitsLetters(state)) {
				throw PLEASE_SELECT_STATE;
			}
			// if (!pincode || !checkForOnlyNumber(pincode)) {
			// 	throw PLEASE_ENTER_PINCODE;
			// }
			if (!addType) {
				throw PLEASE_SELECT_ADDRESS_TYPE;
			}
			if (
				props.userAddressList.find(
					(ele: any) => ele.addressType === addType && addType !== "Other"
				) &&
				!props.match.params.id
			) {
				throw UNIQUE_ADDRESS_TYPE;
			}
			setDisabled(true);
			const payload = {
				addressline1: houseNo,
				addressType: addType,
				city: city.charAt(0).toUpperCase() + city.slice(1),
				country: "United Arab Emirates",
				landmark: landmark,
				postalCode: pincode,
				state: state.charAt(0).toUpperCase() + state.slice(1),
				latitude: props.curLat.toString(),
				longitude: props.curLong.toString(),
			};
			if (!!props.match.params.id) {
				await saveDocumentData(
					props.uid,
					payload,
					COLLECTIONS.USERS,
					COLLECTIONS.ADDRESSES,
					props.match.params.id
				);
				await props.editParticularAddress({
					...payload,
					did: props.match.params.id,
				});
				await props.storeUserEditAddressId("");
				showErrorMsg(ADDRESS_SAVED_SUCCESSFULLY);
				setTimeout(() => {
					props.history.goBack();
				}, 1000);
			} else {
				const Res: any = await saveSubCollectionData(
					props.uid,
					COLLECTIONS.USERS,
					COLLECTIONS.ADDRESSES,
					payload,
					"defaultAddressRef"
				);
				const { did } = Res;
				if (props.userAddressList.length < 1) {
					await props.updateEditedUserDetails({
						defaultAddressRef: `${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.VECHICLES}/${did}`,
					});
					await props.saveAddressRef(did);
				}
				if (!!Res) {
					const storeAdd = [{ ...payload, did: did }];
					props.userAddress(storeAdd);
					showErrorMsg(ADDRESS_SAVED_SUCCESSFULLY);
					setTimeout(() => {
						if (!!props.confirm) {
							props.closeMapModal();
							props.onChangeAddress(storeAdd);
						} else {
							props.history.goBack();
						}
					}, 1000);
					props.storeUserEditAddressId("");
				}
			}
			setDisabled(false);
		} catch (error: any) {
			showErrorMsg(error);
		}
	};

	const handleKeypressAddress = (e: any, type: any) => {
		if (e.key === "Enter") {
			setAddType(type);
		}
	};

	useEffect(() => {
		getLocPermissionStatus();
	}, []);
	const getLocPermissionStatus = async () => {
		// if ((await knowLocationPermission({ ...props })) === DENIED) {
		//   setSearchUi(true);
		// }
		console.error("Stopped Location Permission Api");
	};

	const { isLoaded } = useJsApiLoader({
		id: "google-map-script",
		googleMapsApiKey: GoogleApiKey,
		libraries: ["places"],
	});
	const setTheAdd = (id: any) => {
		const add_arr = props.userAddressList.filter((ele: any) => ele.did === id);
		props.onChangeAddress(add_arr);
		props.closeMapModal();
	};

	React.useEffect(() => {
		document.getElementById("confirm-address")?.scrollTo(0, 0);
	}, [searchUi]);

	return !searchUi ? (
		<IonCol className="middle_panle res_bg_color" size-md="6">
			<ToastMessage
				showToast={toast.showToast}
				ToastMessage={toast.toastMessage}
				severity={toast.severity}
				onDidDismiss={() => {
					setToast({
						showToast: false,
						toastMessage: "",
						severity: "",
					});
				}}
			/>
			{!props.confirm ? (
				!checkMediaQuery() ? (
					<div className="my_address_header">
						<PageHeading
							mainHeader="Add New Address"
							navigation={props}
							cssClass="background-for-non-forms"
						/>
					</div>
				) : (
					<IonIcon
						icon={arrowBackOutline}
						className="add-addresss-navigation wholeApp"
						onClick={() => props.history.goBack()}
					/>
					// <img
					//   src="/images/back_arrow.svg"
					//   className="add-addresss-navigation"
					//   onClick={() => props.history.goBack()}
					// />
				)
			) : (
				<div
					className="confirm_add_head"
					style={{ alignItems: "center" }}
					// className="confirm_modal_panel confirm_add_new_heading"
				>
					<IonLabel className="add_address_head">Add New Address</IonLabel>
					<img
						className="close_icon"
						onClick={() => props.closeMapModal()}
						src="/images/close_popup.svg"
					/>
				</div>
			)}
			<div
				className={
					!!props.confirm ? "confirm-addParentDiv-margin" : "addParentDiv-margin"
				}
			>
				{!!props.curLat && !!props.curLong && (
					<div>
						<Maps lat={Number(props.curLat)} long={Number(props.curLong)} {...props} />
					</div>
				)}
				<div
					className={
						!!props.confirm ? "address-content-confirm-screen" : "address-content"
					}
				>
					<div className={"address-content-inner"}>
						{!!props.map_address && (
							<div className="user_address">
								<IonLabel className="map-address">{props.map_address}</IonLabel>
								<IonButton
									onClick={() => setSearchUi(true)}
									fill="outline"
									color="primary"
								>
									{CHANGE}
								</IonButton>
							</div>
						)}

						<AddressTextField
							style={!!props.confirm && "add_field_margin border_field_label"}
							type="text"
							placetext="House/ Flat no, Street name"
							value={houseNo}
							maxlength={64}
							setValue={(val: any) => setHouseNo(val)}
							checkCondition={false}
						/>
						<AddressTextField
							style={!!props.confirm && "add_field_margin border_field_label"}
							maxlength={64}
							type="text"
							placetext="Landmark"
							value={landmark}
							setValue={(val: any) => {
								setLandmark(val);
							}}
							checkCondition={false}
						/>
						<div className="align_center_csp">
							{(!city.trim().length || !checkMediaQuery()) && (
								<div className="add_pincode_field capitalize">
									<AddressTextField
										style={!!props.confirm && "add_field_margin border_field_label"}
										maxlength={32}
										type="text"
										placetext="City"
										value={city}
										setValue={(val: any) => {
											if (!isSplChar(val)) {
												setCity(val);
											}
										}}
										checkCondition={true}
									/>
								</div>
							)}
							{(!state.trim().length || !checkMediaQuery()) && (
								<div className="add_pincode_field capitalize">
									<AddressTextField
										style={!!props.confirm && "add_field_margin border_field_label"}
										maxlength={32}
										type="text"
										placetext="State"
										value={state}
										setValue={(val: any) => {
											if (!isSplChar(val)) {
												setState(val);
											}
										}}
										checkCondition={true}
										readOnly={true}
									/>
								</div>
							)}

							<div className="add_pincode_field">
								{/* <AddressTextField
            type="number"
            placetext="Pincode"
            value={pincode}
            setValue={(val: any) => setPincode(val)}
          /> */}
								<input
									style={{ cursor: "no-drop", backgroundColor: "#dddddd" }}
									readOnly={true}
									type={"tel"}
									className={
										!!props.confirm
											? "add_field_margin border_field_label"
											: "add_field_margin"
									}
									placeholder={"Pincode"}
									value={pincode}
									maxLength={6}
									onChange={(event) =>
										/^\d+$/.test(event.target.value) || !event.target.value
											? setPincode(event.target.value)
											: null
									}
								/>
								{/* <IonInput
              type="tel"
              className="add_field_margin"
              placeholder="Pincode"
              value={pincode}
              maxlength={6}
              onIonChange={(e: any) => setPincode(e.detail.value)}
            /> */}
							</div>
						</div>
						<IonRadioGroup
							value={addType}
							onIonChange={(e: any) => setAddType(e.detail.value)}
						>
							<div className="align_center addrs_radio_grp_margin">
								{["Home", "Work", "Other"].map((type, index) => (
									<IonItem key={index} lines="none">
										<IonLabel className="addrs_radio_label">{type}</IonLabel>
										<IonRadio
											mode="md"
											tabIndex={0}
											slot="start"
											value={type}
											className="radio_btn_mrgn"
											onKeyPress={(event) => handleKeypressAddress(event, type)}
										/>
									</IonItem>
								))}
							</div>
						</IonRadioGroup>
					</div>
				</div>
				<div
					className={
						!!props.confirm
							? "btn_parent_div confirm_save-address-button"
							: "btn_parent_div save-address-button"
					}
					style={{
						marginRight: 25,
						marginLeft: 25,
						width: "-webkit-fill-available",
					}}
				>
					<IonButton
						className="continue_btn child_btn res_btn_align"
						onClick={() => onSaveAddress()}
						disabled={isDisabled}
						style={{
							marginBottom: 30,
							minWidth: "auto",
							width: "100%",
							maxWidth: checkMediaQuery() ? "none" : 320,
						}}
					>
						<IonLabel color="customwhite">{SAVE}</IonLabel>
					</IonButton>
				</div>
				<ToastMessage
					showToast={!!errorMsg}
					ToastMessage={errorMsg}
					severity={"warning"}
					onDidDismiss={() => {
						showErrorMsg("");
					}}
				/>
			</div>
		</IonCol>
	) : (
		<IonCol className="middle_panle res_bg_color" size-md="6">
			<div
				className={
					!!props.confirm
						? "confirm-addParentDiv-margin confirm-padding-top-20 wholeApp"
						: "addParentDiv-margin search-for-address wholeApp"
				}
				id="confirm-address"
			>
				{!props.confirm ? (
					<ConfirmPageHeading
						customStyle={{
							paddingTop: isPlatform("android") || isPlatform("mobileweb") ? 20 : 0,
						}}
						mainHeader="Search Address"
						navigation={props}
						// onClick={async () => {
						//   if ((await knowLocationPermission({ ...props })) === DENIED) {
						//     if (!!props.closeMapModal) {
						//       props.closeMapModal();
						//     } else {
						//       props.history.goBack();
						//     }
						//   } else {
						//     setSearchUi(false);
						//   }
						// }}
						onClick={async () => {
							setSearchUi(false);
						}}
						showCars={false}
					/>
				) : (
					<div className="search_popup_head">
						<div className="heading_style">
							<div className="back_arrow_aligncenter">
								<img
									src={
										checkMediaQuery()
											? "/images/gray_backarrow.svg"
											: "/images/back_arrow.svg"
									}
									// onClick={async () => {
									//   if (
									//     (await knowLocationPermission({ ...props })) === DENIED
									//   ) {
									//     if (!!props.closeMapModal) {
									//       props.closeMapModal();
									//     } else {
									//       props.history.goBack();
									//     }
									//   } else {
									//     setSearchUi(false);
									//   }
									// }}
									onClick={async () => {
										setSearchUi(false);
									}}
								/>
							</div>
							<div style={{ paddingBottom: 5 }}>
								<IonLabel className="add_address_head">Search Address</IonLabel>
							</div>
						</div>
					</div>
				)}
				{/* <PageHeading mainHeader="Search Address" navigation={props} /> */}
				<div className={!!props.confirm ? "search_popup_main_div" : ""}>
					{isLoaded ? (
						<Autocomplete
							onLoad={(data: any) => setAutocomRef(data)}
							onPlaceChanged={() => onAutoPlaceChanged(autocomRef)}
						>
							<div className="autocomple_parent">
								<input
									type="text"
									placeholder="Enter a location"
									className="autocomplete_input"
								/>
								<IonButton
									className="search_address_btn"
									onClick={() => onAutoPlaceChanged(autocomRef)}
								>
									<IonImg src="/images/search-icon.svg" className="autocomplete_search" />
								</IonButton>
							</div>
						</Autocomplete>
					) : (
						<></>
					)}
					<ToastMessage
						showToast={!!errorMsg}
						ToastMessage={errorMsg}
						severity={"warning"}
						onDidDismiss={() => {
							showErrorMsg("");
						}}
					/>

					{props.locationStatus === DENIED && (
						<ReactTooltip place="bottom" effect="solid" />
					)}
					<div
						ref={(ref) => (fooRef = ref)}
						data-tip="Please allow location permission"
						className="cur_loc_parent"
						// onClick={async () => {
						//   if ((await knowLocationPermission({ ...props })) === DENIED) {
						//     setTooltipText("Please allow location permission");
						//     ReactTooltip.show(fooRef);
						//     setTimeout(() => {
						//       setTooltipText("");
						//       ReactTooltip.hide(fooRef);
						//     }, 5000);
						//   } else {
						//     getUserCurrentLocation();
						//     setSearchUi(false);
						//   }
						// }}
						onClick={() => {
							getUserCurrentLocation();
							setSearchUi(false);
						}}
					>
						<IonImg src="/images/curr_loc.svg" className="cur_loc_insearch" />
						<IonLabel className="cur_loc_text_one">{CURRENT_LOCATION}</IonLabel>
					</div>
					<div className="save_add_parent">
						<IonLabel className="saved_addresses" color="secondary">
							{SAVED_ADDRESS}
						</IonLabel>
						<div style={{ overflow: "hidden" }}>
							<div className="hor_line marLeft0" />
						</div>
					</div>
					{!!props.userAddressList.length ? (
						<div className="address-wrapper">
							{props.userAddressList.map((ele: any, index: any) => (
								<div
									key={index}
									className="address-pill cursor_pointer_style"
									// onClick={async () => {
									//   if (
									//     (await knowLocationPermission({ ...props })) === DENIED
									//   ) {
									//     if (!!props.confirm) {
									//       setTheAdd(ele.did);
									//     } else {
									//       setDefaultAddress(
									//         props.uid,
									//         ele.did,
									//         COLLECTIONS.USERS,
									//         COLLECTIONS.ADDRESSES
									//       );
									//       props.setDefAddress(
									//         `${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.ADDRESSES}/${ele.did}`
									//       );
									//       props.history.push("/portal/my-addresses");
									//     }
									//   } else {
									//     setDefaultAddress(
									//       props.uid,
									//       ele.did,
									//       COLLECTIONS.USERS,
									//       COLLECTIONS.ADDRESSES
									//     );
									//     props.setDefAddress(
									//       `${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.ADDRESSES}/${ele.did}`
									//     );
									//     props.history.push("/portal/my-addresses");
									//   }
									// }}
									onClick={async () => {
										setDefaultAddress(
											props.uid,
											ele.did,
											COLLECTIONS.USERS,
											COLLECTIONS.ADDRESSES
										);
										props.setDefAddress(
											`${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.ADDRESSES}/${ele.did}`
										);
										props.history.push("/portal/my-addresses");
									}}
								>
									<div
										className={
											(props.defaultAddressRef || "").split("/").pop() === ele.did
												? "defadd-container"
												: "defadd-container-empty"
										}
									>
										{(props.defaultAddressRef || "").split("/").pop() === ele.did && (
											<IonLabel className="defadd-text">{"Default"}</IonLabel>
										)}
									</div>

									<IonLabel className="address-type">{ele.addressType}</IonLabel>
									<IonLabel className="address-fulladd">
										{ele.addressline1}
										{", "}
										{ele.landmark}
										{", "}
										{ele.city}
										{", "}
										{ele.postalCode}
										{", "}
										{ele.country}
									</IonLabel>
								</div>
							))}
						</div>
					) : (
						<div className="pro_add">
							<IonLabel className="no_save_add">{NO_SAVED_ADDRESS}</IonLabel>
						</div>
					)}
				</div>
			</div>
		</IonCol>
	);
};

export default connect(
	({ userInfo, auth }: any) => {
		const {
			map_address,
			curLat,
			curLong,
			userAddressList,
			storeCity,
			storeState,
			storePincode,
			edit_address_id,
			userVehiclesList,
			locationStatus,
		} = userInfo;
		const { uid, onBoarding, selectedVehicleRef } = auth;
		return {
			map_address,
			curLat,
			curLong,
			uid,
			userAddressList,
			storeCity,
			storeState,
			storePincode,
			edit_address_id,
			userVehiclesList,
			onBoarding,
			selectedVehicleRef,
			locationStatus,
		};
	},
	{
		storeUserMapAddress,
		storeCurrentLatLong,
		userAddress,
		storeCityAndState,
		updateEditedUserDetails,
		storeUserEditAddressId,
		setDefAddress,
		editParticularAddress,
		saveLocationPermissionStatus,
		saveAddressRef,
	}
)(AddNewAddress);
